<div class="front-page-wrapper">
  <app-top-banner></app-top-banner>

  <!-- Notification sticker -->
  <div class="notification-sticker">
    <app-teaser-top-mobile *appShellNoRender></app-teaser-top-mobile>
  </div>

  <!-- Categories header -->
  <ng-container *ngIf="categories else categoriesSpan">
    <app-swiper-categories-template [data]="categories" (categoryClick)="onSwiperCategoryClick($event)" />
  </ng-container>

  <!-- Placeholder when no categories -->
  <ng-template #categoriesSpan>
    <span style="display: block; width: 100%; height: 84px;"></span>
  </ng-template>

  <!-- My games -->
  <ng-container *loggedRender>
    <app-my-games-list></app-my-games-list>
  </ng-container>

  <!-- Game Cards -->
  <!-- <app-game-category-short [data]="categories | slice : 0  : 1"></app-game-category-short> -->

  <ng-container *ngIf="categories else gamesSpan">
    <ng-container *ngFor="let category of categories | slice : 0 : 2">
      <app-swiper-grid-template
        [category]="category"
        (gameClick)="onGameClick($event)"
      />
    </ng-container>
  </ng-container>

  <!-- -------------------------------------------------------------------------------------------------------------- -->
  
  <!-- jackpot -->

   <app-home-page-jackpot></app-home-page-jackpot>
  
  <!-- -------------------------------------------------------------------------------------------------------------- -->
  
  <!-- Game Cards -->
  <ng-container *ngIf="categories else gamesSpan">
    <ng-container *ngFor="let category of categories | slice : 2 : 4">
      <app-swiper-grid-template [category]="category" (gameClick)="onGameClick($event)" />
    </ng-container>
  </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->

  <!-- Tournaments -->
  <!-- <div class="categoryNameContainer" fxLayout="row" fxLayoutAlign="center center">
    <h2 fxLayoutAlign="center center" class="category-title">
      <img class="category-icon" src="assets/luckera/icons/icon-tournament.svg" alt="icon-category-tournament">
      <span i18n>Tournaments</span>
    </h2>
    <span class="spacer"></span>
    <a class="button-all-games" fxLayoutAlign="end center" fxLayout="row" [routerLink]="['/', tournamentsAllTrx]">
      <span i18n>More</span>
      <div>
        <img src="{{licenceService.getKey('arrow-icon')}}" icon-btn size="large">
      </div>
    </a>
  </div>
  <ng-container #tournaments>
    <div *ngIf="isShowTournamentsModulePlaceholder">
      <div style="height: 128px">
      </div>
    </div>
  </ng-container> -->
  <!-- -------------------------------------------------------------------------------------------------------------- -->

  <!-- <ng-container #reactivation>
    <div *ngIf="isShowRectivationModulePlaceholder">
      <div style="height: 128px">
      </div>
    </div>
  </ng-container> -->
  <!-- <ng-container #xmas>
    <div *ngIf="isShowXmasModulePlaceholder">
      <div style="height: 128px">
      </div>
    </div>
  </ng-container> -->

  <!-- Game Cards -->
  <ng-container *ngIf="categories else gamesSpan">
    <ng-container *ngFor="let category of categories | slice : 4 : 6">
      <app-swiper-grid-template
        [category]="category"
        (gameClick)="onGameClick($event)"
      />
    </ng-container>
  </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->

  <!-- Lemon missions -->
  <ng-container #missions>
    <div class="categoryNameContainer" fxLayout="row" fxLayoutAlign="center center">
      <h2 fxLayoutAlign="center center" class="category-title">
        <img class="category-icon" src="assets/icons/mission-home-page-icon.svg" alt="mission-home-page-icon">
        <span i18n>Missions</span>
      </h2>
      <span class="spacer"></span>
      <a class="button-all-games" fxLayoutAlign="end center" fxLayout="row" [routerLink]="['/', missionsAllTrx]">
        <span i18n>More</span>
      </a>
    </div>
    <div *ngIf="isShowMissionsModulePlaceholder">
      <div style="height: 128px">
      </div>
    </div>
  </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->

  <!-- Lemon missions -->
  <!-- <ng-container #missions>
    <div class="categoryNameContainer" fxLayout="row" fxLayoutAlign="center center">
      <h2 fxLayoutAlign="center center" class="category-title">
        <img class="category-icon" src="assets/icons/mission-home-page-icon.svg" alt="mission-home-page-icon">
        <span i18n>Missions</span>
      </h2>
      <span class="spacer"></span>
      <a class="button-all-games" fxLayoutAlign="end center" fxLayout="row" [routerLink]="['/', missionsAllTrx]">
        <span i18n>More</span>
        <img src="{{licenceService.getKey('arrow-icon')}}" alt="arrow" icon-btn size="large">
      </a>
    </div>
    <div *ngIf="isShowMissionsModulePlaceholder">
      <div style="height: 128px">
      </div>
    </div>
  </ng-container> -->
  <!-- -------------------------------------------------------------------------------------------------------------- -->

  <!-- Game Cards -->
  <ng-container *ngIf="categories else gamesSpan">
    <ng-container *ngFor="let category of categories | slice : 6 : 7">
      <app-swiper-grid-template
        [category]="category"
        (gameClick)="onGameClick($event)"
      />
    </ng-container>
  </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->
  
  <!-- Reactivation Campaign -->
      <ng-container #reactivation>
        <div *ngIf="isShowRectivationModulePlaceholder">
          <div style="height: 128px"></div>
        </div>
      </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->
  
  <!-- Game Cards -->
      <ng-container *ngIf="categories else gamesSpan">
        <ng-container *ngFor="let category of categories | slice : 7 : 8">
          <app-swiper-grid-template
            [category]="category"
            (gameClick)="onGameClick($event)"
          />
        </ng-container>
      </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->
  
      <!-- promotions slider -->
      <ng-container #promotion>
        <div *ngIf="isShowPromotionsModulePlaceholder">
          <div style="height: 128px"></div>
        </div>
      </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->
  
  <!-- Game Cards -->
  <ng-container *ngIf="categories else gamesSpan">
    <ng-container *ngFor="let category of categories | slice : 8 : 9">
      <app-swiper-grid-template [category]="category" (gameClick)="onGameClick($event)" />
    </ng-container>
  </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->

  <!-- balance bar -->
  <!-- <app-home-page-account-balance *loggedRender></app-home-page-account-balance> -->
  <!-- -------------------------------------------------------------------------------------------------------------- -->
  
  <!-- Game Cards -->
      <ng-container *ngIf="categories else gamesSpan">
        <ng-container *ngFor="let category of categories | slice : 9 : 10">
          <app-swiper-grid-template
            [category]="category"
            (gameClick)="onGameClick($event)"
          />
        </ng-container>
      </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->
      <!-- Top Providers -->
      <!-- <app-game-operator-short *ngIf="operators" [operators]="operators"></app-game-operator-short> -->
      <div class="swiper-container">
        <app-game-operator-short *ngIf="operators" [operators]="operators" class="game-operator-wrap mobile"></app-game-operator-short>
      </div>


      <!-- Game Cards -->
      <ng-container *ngIf="categories else gamesSpan">
        <ng-container *ngFor="let category of categories | slice : 10">
          <app-swiper-grid-template
            [category]="category"
            (gameClick)="onGameClick($event)"
          />
        </ng-container>
      </ng-container>
  <!-- -------------------------------------------------------------------------------------------------------------- -->

  <!-- Expansion panel -->
  <app-front-expansion-panel id="expansionPanel" [data]="expansionPanel"></app-front-expansion-panel>

  <!-- Games placeholder -->
  <ng-template #gamesSpan>
    <span style="display: block; width: 100%; height: 410px;"></span>
  </ng-template>
</div>

<!-- Mobile router outlet -->
<ng-container *ngIf="!detectDeviceService.isDesktop()">
  <router-outlet></router-outlet>
</ng-container>